<template>
  <div class="animated fadeIn">
    <form @submit.stop.prevent="imprimir()">
      <b-row>
        <b-col sm="12">
          <b-card id="card-relatorio" 
            :bg-variant="isDark ? 'dark' : 'white'" 
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
            
            <div slot="header" class="d-flex align-items-center justify-content-between" :class="isDark ? 'bg-dark border-secondary' : ''">
                <div>
                  <i class='fa fa-truck mr-2'></i><strong>Relatório de Compra de Gado</strong>
                </div>
            </div>

            <!-- Seção 1: Tipo e Configuração -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-cog mr-2"></i>Tipo de Relatório</h6>
              <b-row>
                <b-col md="8" sm="12">
                  <b-form-group label="Selecione o tipo de Relatório">
                    <b-form-select :plain="true" v-model="tipoRel.valor" :options="tipoRel.opcoes" :class="isDark ? 'bg-secondary text-white border-info' : ''" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12" v-if="['2'].includes(tipoRel.valor)">
                  <b-form-group label="Agrupamento">
                    <b-form-select :plain="true" v-model="tipoGrupo.valor" :options="tipoGrupo.opcoes" :class="isDark ? 'bg-secondary text-white border-info' : ''" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4" sm="12">
                  <b-form-group label="Tipo de Documento">
                    <b-form-select :plain="true" v-model="tipoDocumento.valor" :options="tipoDocumento.opcoes" :class="isDark ? 'bg-secondary text-white border-info' : ''" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                  <b-form-group label="Situação">
                    <b-form-select :plain="true" v-model="tipoSituacao.valor" :options="tipoSituacao.opcoes" :class="isDark ? 'bg-secondary text-white border-info' : ''" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                  <b-form-group label="Ordenação">
                    <b-form-select v-if="tipoRel.valor === '1' || tipoRel.valor === '3' || tipoRel.valor === '4'" 
                      :plain="true" v-model="tipoOrdenacao.valor" :options="tipoOrdenacao.opcoesSintetico" :class="isDark ? 'bg-secondary text-white border-info' : ''" />
                    <b-form-select v-else 
                      :plain="true" v-model="tipoOrdenacao.valor" :options="tipoOrdenacao.opcoesFinanceiro" :class="isDark ? 'bg-secondary text-white border-info' : ''" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 2: Filtros Principais -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-filter mr-2"></i>Filtros Principais</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Fornecedor">
                    <cliente-pesquisa 
                      @retornaId="registro.CLIENTE_ID = $event"
                      :idInicial="registro.CLIENTE_ID"
                      place="Todos os fornecedores"
                      ref="clientepesquisa"
                      idModal="clientepesquisa"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Comprador">
                    <funcionario-dropdown
                      v-model="registro.FUNCIONARIO_ID"
                      ref="funcionariopesquisa"
                      placeholder="Todos os compradores"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 3: Período -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Período</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Início">
                    <cec-input-data id="dt1" v-model="registro.DT1" :state="registro.DT1 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Fim">
                    <cec-input-data id="dt2" v-model="registro.DT2" :state="registro.DT2 ? null : false" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div slot="footer" class="p-3" :class="isDark ? 'bg-dark border-top border-secondary' : 'bg-light'">
              <b-row class="justify-content-center">
                <b-col md="4" sm="12">
                  <b-button block size="lg" type="button" variant="primary" @click.stop.prevent="imprimir()" class="btn-generate shadow-sm">
                    <i class="fa fa-file-pdf-o mr-2"></i> GERAR RELATÓRIO
                  </b-button>              
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import FuncionarioDropdown from '../componentes/dropdown/FuncionarioDropdown.vue'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import moment from 'moment'

export default {
  data () {
    return {
      registro: {
        CLIENTE_ID: null,
        FUNCIONARIO_ID: null,
        DT1: moment().format('YYYY-MM-DD'),
        DT2: moment().format('YYYY-MM-DD')
      },
      tipoRel: {
        valor: '1',
        opcoes: [
          { text: 'Resumido - Informações Sintéticas', value: '1' },
          { text: 'Resumo Financeiro', value: '2' },
          { text: 'Resumo Sintético', value: '3' },
          { text: 'Resumo Sintético - Seleção Manual', value: '4' }
        ]
      },
      tipoDocumento: {
        opcoes: [
          { value: '', text: 'Todos' },
          { value: '0', text: 'Minuta' },
          { value: '1', text: 'Nota Fiscal' },
          { value: '2', text: 'Romaneio' },
          { value: '3', text: 'Pedido' },
          { value: '4', text: 'Avulso' }
        ],
        valor: ''
      },
      tipoOrdenacao: {
        opcoesSintetico: [
          { value: '1', text: 'Por Data' },
          { value: '2', text: 'Por Fornecedor' },
          { value: '3', text: 'Por Número de Controle' }
        ],
        opcoesFinanceiro: [
          { value: '1', text: 'Por Vencimento' },
          { value: '2', text: 'Por Fornecedor' }
        ],
        valor: '1'
      },
      tipoSituacao: {
        opcoes: [
          { value: '', text: 'Todos' },
          { value: '1', text: 'Lançando/Fechado' },
          { value: '2', text: 'Cancelado' }
        ],
        valor: ''
      },
      tipoGrupo: {
        opcoes: [
          { value: 'F', text: 'Fornecedor' },
          { value: 'D', text: 'Vencimento' }
        ],
        valor: 'D'
      },
      isLoading: false
    }
  },
  components: {
    FuncionarioDropdown,
    ClientePesquisa,
    CecInputData
  },
  computed: {
    isDark () {
      return this.$store.getters['tema/IS_DARK']
    },
    isValid () {
      return !!this.registro.DT1 && !!this.registro.DT2
    }
  },
  methods: {
    imprimir () {
      if (!this.isValid) {
        this.$toast.warn({
          title: 'Aviso',
          message: 'Por favor, informe o período desejado',
          progressBar: false,
          showMethod: 'shake',
          position: 'top full width'
        })
        return
      }

      this.$store.commit('controle/setAguardando', true)
      this.isLoading = true

      const params = {
        dt1: this.registro.DT1,
        dt2: this.registro.DT2,
        lbUsuario: window.localStorage.getItem('nomeusuario'),
        lbEmpresa: window.localStorage.getItem('nomeempresa'),
        tipoRel: this.tipoRel.valor,
        ordem: this.tipoOrdenacao.valor,
        tipoSituacao: this.tipoSituacao.valor,
        tipoDocumento: this.tipoDocumento.valor
      }

      if (this.registro.CLIENTE_ID) {
        params.fornecedorid = this.registro.CLIENTE_ID
        params.lbFornecedor = this.$refs.clientepesquisa?.$refs?.auto?.display || ''
      }
      if (this.registro.FUNCIONARIO_ID) {
        params.funcionarioId = this.registro.FUNCIONARIO_ID
        params.lbFuncionario = this.getLabelFromDropDown('funcionariopesquisa', this.registro.FUNCIONARIO_ID)
      }
      if (this.tipoRel.valor === '2') {
        params.tipoGrupo = this.tipoGrupo.valor
      }

      const uri = '/api/protected/relatorios/relcompragadoresumidoforcomp?' + new URLSearchParams(params).toString()

      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          this.isLoading = false
          this.$toast.success({
            title: 'Sucesso',
            message: 'Relatório Gerado com Sucesso',
            progressBar: false,
            timeOut: 3000,
            showMethod: 'shake',
            position: 'top full width'
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          window.open(url)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          this.isLoading = false
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatório',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
        })
    },
    getLabelFromDropDown (refName, value) {
      if (!value) return ''
      const component = this.$refs[refName]
      if (component && component.options) {
        const option = component.options.find(o => o.value === value)
        return option ? option.text : ''
      }
      return ''
    }
  }
}
</script>

<style scoped>
.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e4e7ea;
  transition: all 0.3s ease;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.section-container.dark-mode {
  background: #2f353a;
  border-color: #434a50;
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #434a50;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  padding: 12px;
  transition: all 0.3s;
}

.btn-generate:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(32, 168, 216, 0.4);
}

.dark-mode .form-group label {
  color: #a4b7c1;
}

#card-relatorio {
  border-radius: 12px;
  overflow: hidden;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelCompraGado.vue